module.exports = __webpack_public_path__ + "static/img/gold 2.9ed7fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/gold 2.png
// module id = bzVE
// module chunks = 35